import {observable, action, runInAction} from 'mobx'
import {PAGE_SIZE_DEFAULT} from '../constants/appConstant'
import mappingManagementAPI from '../apis/mappingManagementAPI'
import alertMessage from '../utils/alertMessage'
import {Base64} from 'js-base64'

export default class MappingManagementStore {
  constructor(rootStore) {
    this.rootStore = rootStore
  }

  @observable isFetching = false
  @observable isFetchingAdd = false
  @observable pageSize = PAGE_SIZE_DEFAULT
  @observable pageNo = 1
  @observable currIndex = 0
  @observable itemCount = 0

  /*search mapping list start*/
  @observable searchItem = {
    mappingName: '',
    inboundCustomer: null,
    inBoundName: '',
    outboundCustomer: null,
    outBoundName: '',
    loadStatus: null,
  }
  @observable mappingList = []
  @observable mappingNames = []

  @action
  async onSearchAction(searchItem, pageNo, pageSize) {
    this.isFetching = true
    try {
      this.mappingList = []
      this.mappingNames = []
      this.searchItem = searchItem
      const response = await mappingManagementAPI.searchAction(searchItem, pageNo, pageSize)
      runInAction(() => {
        this.isFetching = false
        if (response.data.code !== 0) {
          alertMessage.error('Failed！ Data Platfrom no data!')
        } else {
          // for(var i=0; i<response.data.data?.content.length;i++) {
          //   response.data.data.content[i].createTime=response.data.data.content[i].createTime.slice(0,10)
          //   response.data.data.content[i].updateTime=response.data.data.content[i].updateTime.slice(0,10)
          // }
          this.mappingList = response.data.data?.records || []
          this.mappingNames = response.data.data?.records.sort(function (a, b) {
            return a.name.toLowerCase().localeCompare(b.name.toLowerCase())
          })
          this.itemCount = response.data.data?.total
        }
      })
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  /*search mapping list end*/
  /*Inbound list*/
  @observable searchItemInbound = {
    // createDateBegin: "",
    // createDateEnd: "",
    inboundCustomer: null,
    // apiName: '',
    // name: '',
    // status: null,
  }
  @observable inboundCustomerList = []

  @action
  async onGetinboundCustomerAction(searchItem) {
    try {
      this.inboundCustomerList = []
      this.searchItemInbound = searchItem
      const response = await mappingManagementAPI.getCustAction(searchItem)
      runInAction(() => {
        if (response.data.data === null) {
          alertMessage.error('Failed！ Data Platfrom no data!')
        } else {
          this.inboundCustomerList = response.data.data
        }
      })
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
      })
    }
  }

  @observable inboundNameList = []

  @action
  async onGetInboundNameAction(searchItem, isMultiple = false, type) {
    this.isFetchingAdd = true
    try {
      let response
      this.inboundNameList = []
      this.searchItemInbound = searchItem

      if (type === 'inbound') {
        response = await mappingManagementAPI.getInboundNameWithoutHttpAction(searchItem)
      } else {
        response = await mappingManagementAPI.getInboundNameAction(searchItem)
      }
      runInAction(() => {
        this.isFetchingAdd = false
        if (response.data.data === null) {
          alertMessage.error('Failed！ Data Platfrom no data!')
        } else {
          if (!isMultiple) {
            this.inboundNameList = response.data.data
          } else {
            this.inboundNameList = this.inboundNameList.concat(response.data.data)
          }
        }
      })
      return response.data.data
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetchingAdd = false
      })
    }
  }

  @action
  async onGetInboundNamesAction(searchItem) {
    this.isFetchingAdd = true
    try {
      this.inboundNameList = []
      this.searchItemInbound = searchItem
      const response = await mappingManagementAPI.getInboundNamesAction(searchItem)
      runInAction(() => {
        this.isFetchingAdd = false
        if (response.data.data === null) {
          alertMessage.error('Failed！ Data Platfrom no data!')
        } else {
          this.inboundNameList = response.data.data
        }
      })
      return response.data.data
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetchingAdd = false
      })
    }
  }

  @observable inboundCustomerNameDetails = {}
  @observable inboundList = []
  @observable inboundListDefault = []
  @observable inboundListRules = []
  @observable inboundListTree = []
  @observable formulaInfos = []

  @action
  async onGetFormulaInfosAction() {
    try {
      this.formulaInfos = {}
      const response = await mappingManagementAPI.getFormulaInfoList()
      runInAction(() => {
        if (response.data.data === null) {
          alertMessage.error('Failed！ Data Formula no data!')
        } else {
          this.formulaInfos = response.data.data
        }
      })
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
      })
    }
  }

  @action
  async onGetInboundAction(searchItem) {
    try {
      this.inboundCustomerNameDetails = {}
      this.searchItemInbound = searchItem
      const response = await mappingManagementAPI.getInboundAction(searchItem)
      runInAction(() => {
        if (response.data.data === null) {
          alertMessage.error('Failed！ Data Platfrom no data!')
        } else {
          this.inboundCustomerNameDetails = response.data.data ? response.data.data : {}
          let newTree = response.data.data?.fieldSet
          // newTree=JSON.parse(JSON.stringify(newTree)?.replace(/\./g,'/'))
          // newTree=JSON.parse(JSON.stringify(newTree)?.replace(/"path"/g,'"key"'))
          this.inboundListTree = newTree
          let newArr = this.flatTree(response.data.data?.fieldSet, 0)
          newArr = JSON.parse(JSON.stringify(newArr).replace(/\./g, '/'))
          this.inboundList = newArr
        }
      })
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
      })
    }
  }

  /*Outbound list*/
  @observable searchItemOutbound = {
    // createDateBegin: "",
    // createDateEnd: "",
    outboundCustomer: null,
    // apiName: '',
    // name: '',
    // status: null,
  }
  @observable outboundCustomerList = []

  @action
  async onGetoutboundCustomerAction(searchItem) {
    try {
      this.outboundCustomerList = []
      this.searchItemOutbound = searchItem
      const response = await mappingManagementAPI.getCustAction(searchItem)
      runInAction(() => {
        if (response.data.data === null) {
          alertMessage.error('Failed！ Data Platfrom no data!')
        } else {
          this.outboundCustomerList = response.data.data
        }
      })
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
      })
    }
  }

  @observable outboundNameList = []

  @action
  async onGetOutboundNameAction(searchItem) {
    this.isFetchingAdd = true
    try {
      this.outboundNameList = []
      this.searchItemOutbound = searchItem
      const response = await mappingManagementAPI.getOutboundNameAction(searchItem)
      runInAction(() => {
        this.isFetchingAdd = false
        if (response.data.data === null) {
          alertMessage.error('Failed！ Data Platfrom no data!')
        } else {
          this.outboundNameList = response.data.data
        }
      })
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetchingAdd = false
      })
    }
  }

  @observable outboundCustomerNameDetails = {}
  @observable outboundList = {}

  @action
  async onGetOutboundAction(searchItem) {
    try {
      this.outboundCustomerNameDetails = {}
      this.searchItemOutbound = searchItem
      const response = await mappingManagementAPI.getOutboundAction(searchItem)
      runInAction(() => {
        if (response.data.data === null) {
          alertMessage.error('Failed！ Data Platfrom no data!')
        } else {
          this.outboundCustomerNameDetails = response.data.data ? response.data.data : {}
          let newArr = this.flatTree(response.data.data?.fieldSet, 0) || []
          newArr = JSON.parse(JSON.stringify(newArr).replace(/\./g, '/'))
          let newArrObj = []
          for (var i = 0; i < newArr.length; i++) {
            newArrObj.push({'fieldInfo': newArr[i]})
          }
          this.outboundList = newArr
          this.getFieldAction(newArrObj)
        }
      })
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
      })
    }
  }

  /*fieldDataSource start*/
  @observable fieldDataSourceEncryption = []
  @observable fieldDataSource = []

  @action
  flatTree(nodes, parentId) {  //tree to arrif (!nodes || nodes.length === 0) return [];
    let result = []

    function flatTreeFun(nodes, parentId) {
      if (!nodes || nodes.length === 0) return []
      nodes.forEach(node => {
        result.push({
          name: node.name,
          parentId: parentId,
          path: node.path,
          fieldType: node.fieldType,
          arrayType: node.arrayType,
          children: node.children,
          format: node.format,
          length: node.length
        })
        return flatTreeFun(node.children, node.path)
      })
    }

    flatTreeFun(nodes, parentId)

    return result
  }

  @action
  getFieldAction(value) {  // new table dataSource
    let newArr = []
    value.map((item, index) => {
      return newArr.push(Object.assign({}, item, {naturalKey: false, computationExpression: '', dependFields: null}))
    })
    this.fieldDataSource = newArr
  }

  /*Add Key start*/
  @observable addKeyList = []

  @action
  onChangeAddKey(value) {
    const diffParams = []
    this.addKeyList.reduce((arr, item) => {
      !value.includes(item) && diffParams.push(item)
      return diffParams
    }, [])
    for (let i = 0; i < value.length; i++) {
      this.fieldDataSource.filter((item, index) => item.fieldInfo.path === value[i]).map((it, ind) => {
        return it.naturalKey = true
      })
    }
    for (let j = 0; j < diffParams.length; j++) {
      this.fieldDataSource.filter((item, index) => item.fieldInfo.path === diffParams[j]).map((it, ind) => {
        return it.naturalKey = false
      })
    }
    this.addKeyList = value
  }

  /*Add Key end*/

  /*add inbound mapping fieldInfo*/
  @action
  onAddFieldDataSource(value) {
    this.fieldDataSource.filter((item, index) => index === value).map((it, i) => {
      return it.dependFields.push({path: null, fieldType: null, name: '', arrayType: null, children: null, format: '', length: null,})
    })
  }

  /*delete inbound mapping fieldInfo*/
  @action
  onDelFieldDataSource(value, ids) {
    this.fieldDataSource.filter((item, index) => index === value).map((it, i) => {
      return it.dependFields.splice(ids, 1)
    })
  }

  /*add/edit inbound mapping rules*/
  @action
  onChangeRulesDataSource(ids, value, fields) {
    this.fieldDataSource.filter((item, index) => index === ids).map((it, i) => {
      // eslint-disable-next-line no-sequences
      return it.computationExpression = value, it.dependFields = fields
    })
  }

  /*fieldDataSource end*/
  /*Api Filter start*/
  @observable filtersDataSourceEncryption = []
  @observable filtersDataSource = []

  @action
  onChangeFilter(value) {
    this.filtersDataSource = value
  }

  /*Api Filter end*/
  /*Pre Filter start*/

  @observable preProcessingDataSourceEncryption = []
  @observable preProcessingDataSource = []

  @action
  onChangePreFilter(value) {
    this.preProcessingDataSource = value
  }

  /*Pre Filter end*/


  /*add/edit save mapping*/
  @action
  async onSaveMappingAction(params) {
    this.isFetching = true
    try {
      const response = await mappingManagementAPI.saveAction(params)
      runInAction(() => {
        this.isFetching = false
        if (response.data && response.data.code === 0) {
          alertMessage.success('Save Success！')
          this.onSearchAction(this.searchItem, this.pageNo, this.pageSize)
        } else {
          alertMessage.error('Save Failed！' + response.data?.message + '')
        }
      })
      return response
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  /*Id --- Mapping Details*/
  @observable mappingDetails = null
  @observable mappingDefaultDetails = null

  @action
  async onDetailsAction(id) {
    this.isFetching = true
    try {
      const response = await mappingManagementAPI.detailsAction(id)
      runInAction(() => {
        this.isFetching = false
        if (response.data.data === null) {
          alertMessage.error('Failed！ Data Platfrom no data!')
        } else {
          this.fieldDataSource = []
          // response.data.data.dataFieldMappings.filter(item=>item.dependFields.length<=0||item.dependFields===null).map((it, index)=>{
          //   return it.dependFields.push({path:null,fieldType:null,name:'', arrayType: null, children: null, format: '', length: null})
          // })
          this.mappingDefaultDetails = response.data.data || null
          this.mappingDetails = response.data.data || null
          let keyList = this.mappingDetails?.dataFieldMappings?.filter((item, i) => item.naturalKey) || []
          for (var i = 0; i < keyList.length; i++) {
            this.addKeyList.push(keyList[i].fieldInfo.path)
          }
          this.inboundListDefault = JSON.parse(JSON.stringify(this.flatTree(this.mappingDetails?.inboundConfigInfo?.fieldInfos, 0)))
          this.inboundListTree = this.mappingDetails?.inboundConfigInfo?.fieldInfos
          this.inboundList = JSON.parse(JSON.stringify(this.flatTree(this.mappingDetails?.inboundConfigInfo?.fieldInfos, 0)).replace(/\./g, '/'))
          JSON.parse(JSON.stringify(this.flatTree(this.mappingDetails?.inboundConfigInfo?.fieldInfos, 0))).map(item => {
            return this.inboundListRules.push(item.path)
          })
          this.filtersDataSource = response.data.data?.fieldFilters || []
          // this.preProcessingDataSource= response.data.data?.preProcessing || []
          let outboundList = this.mappingDetails?.outboundConfigInfo?.fieldInfos !== null ? this.flatTree(this.mappingDetails?.outboundConfigInfo?.fieldInfos, 0) : []
          this.outboundList = outboundList.map(item => {
            delete item.children
            return item
          })
          for (var j = 0; j < outboundList.length; j++) {
            this.fieldDataSource.push({naturalKey: false, dependFields: null, computationExpression: '', fieldInfo: outboundList[j]})
          }
          for (var k = 0; k < this.mappingDetails.dataFieldMappings.length; k++) {
            // eslint-disable-next-line no-loop-func
            this.fieldDataSource.filter((item) => item.fieldInfo.path === this.mappingDetails.dataFieldMappings[k].fieldInfo.path).map((it) => {
              // eslint-disable-next-line no-sequences
              return it.naturalKey = this.mappingDetails.dataFieldMappings[k].naturalKey, it.dependFields = this.mappingDetails.dataFieldMappings[k].dependFields, it.computationExpression = this.mappingDetails.dataFieldMappings[k].computationExpression
            })
          }
        }
      })
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  @action
  onChangefieldDataSource(value) {
    this.fieldDataSource = value
  }

  /*Base64*/
  @action
  encryptionAction() {
    const fieldDataSourceList = JSON.parse(JSON.stringify(this.fieldDataSource))
    const filtersDataSourceList = JSON.parse(JSON.stringify(this.filtersDataSource))
    const preProcessingDataSourceList = JSON.parse(JSON.stringify(this.preProcessingDataSource))
    for (let i = 0; i < fieldDataSourceList.length; i++) {
      fieldDataSourceList[i].computationExpression = Base64.encode(fieldDataSourceList[i].computationExpression)
    }
    for (let i = 0; i < filtersDataSourceList.length; i++) {
      filtersDataSourceList[i].computationExpression = Base64.encode(filtersDataSourceList[i].computationExpression)
    }
    for (let i = 0; i < preProcessingDataSourceList.length; i++) {
      preProcessingDataSourceList[i].computationExpression = Base64.encode(preProcessingDataSourceList[i].computationExpression)
    }
    this.fieldDataSourceEncryption = fieldDataSourceList
    this.filtersDataSourceEncryption = filtersDataSourceList
    this.preProcessingDataSourceEncryption = preProcessingDataSourceList
  }

  @action
  onChangeMappingDetails() {
    this.mappingDetails = this.mappingDefaultDetails
    this.addKeyList = []
  }

  /*activeAction*/
  @action
  async onActiveAction(id, params) {
    this.isFetching = true
    try {
      const response = await mappingManagementAPI.activeAction(id, params)
      runInAction(() => {
        this.isFetching = false
        if (response.data.code === 0) {
          alertMessage.success('Success！')
          this.onSearchAction(this.searchItem, this.pageNo, this.pageSize)
        } else {
          alertMessage.error('Failed！' + response.data.message + '')
        }
      })
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  /*delete*/
  @action
  async onDeleteAction(id) {
    this.isFetching = true
    try {
      const response = await mappingManagementAPI.deleteAction(id)
      runInAction(() => {
        this.isFetching = false
        if (response.data.code === 0) {
          alertMessage.success('Delete Success！')
          this.onSearchAction(this.searchItem, this.pageNo, this.pageSize)
        } else {
          alertMessage.error('Delete Failed！' + response.data.message + '')
        }
      })
      return response
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  /*get version*/
  @observable versionList = []

  @action
  async onSearchVersionAction(id, versionType) {
    this.isFetching = true
    try {
      this.versionList = []
      const response = await mappingManagementAPI.getVersion(id, versionType)
      runInAction(() => {
        this.isFetching = false
        if (response.data.code === 0 && response.data.data !== null) {
          for (var i = 0; i < response.data.data.length; i++) {
            response.data.data[i].updateTime = response.data.data[i].updateTime.slice(0, 10)
          }
          this.versionList = response.data.data || []
        } else {
          alertMessage.error('Failed！ Data Platfrom no data!')
        }
      })
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  /*save current version*/
  @action
  async onSaveVersionAction(id, versionType, param) {
    this.isFetching = true
    try {
      this.versionList = []
      const response = await mappingManagementAPI.saveVersion(id, versionType, param)
      runInAction(() => {
        this.isFetching = false
        if (response.data.code === 0) {
          alertMessage.success('Save Success！')
          this.onSearchVersionAction(id, versionType)
        } else {
          alertMessage.error('Save Failed！' + response.data.message + '')
        }
      })
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  /*roll back*/
  @action
  async onSaveRollbackAction(id, versionId, versionType, param) {
    this.isFetching = true
    try {
      const response = await mappingManagementAPI.saveRollbackAction(id, versionId, versionType, param)
      runInAction(() => {
        this.isFetching = false
        if (response.data.code === 0) {
          alertMessage.success('Save Success！')
          this.onSearchVersionAction(id, versionType)
        } else {
          alertMessage.error('Save Failed！' + response.data.message + '')
        }
      })
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  /*change page*/
  @action
  onChangePageNumAction(pageNo, pageSize) {
    if (this.pageNo === pageNo && (!pageSize || this.pageSize === pageSize)) {
      return
    }
    runInAction(() => {
      this.pageNo = pageNo
      this.pageSize = pageSize
    })
    this.onSearchAction(this.searchItem, this.pageNo, this.pageSize)
  }

  @action
  onChangePageNo() {
    this.itemCount = 0
    this.pageNo = 1
    this.pageSize = PAGE_SIZE_DEFAULT
  }

  @action
  sortExp(key, isAsc) {
    return function (x, y) {
      if (isNaN(key)) {
        if (x[key] > y[key]) {
          return 1 * (isAsc ? 1 : -1)

        } else if (x[key] < y[key]) {
          return -1 * (isAsc ? 1 : -1)
        } else {
          return 0
        }

      } else {
        return (x[key] - y[key]) * (isAsc ? 1 : -1)
      }
    }
  }
}
